"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileList = void 0;
var React = require("react");
var t = require("io-ts");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var components_1 = require("components");
var moment = require("moment");
var uuid_1 = require("uuid");
var FileIcon_1 = require("components/FileIcon");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
require("./style.scss");
var headers = ['color', 'name', 'description', 'author', 'added'];
var iHeaders = t.interface({
    color: t.string,
    name: t.string,
    description: t.string,
    author: t.string,
    added: t.string
});
var calculateColumns = function (meta) {
    var metaIdLookup = meta.reduce(function (prev, c) {
        if (c.id) {
            prev[c.identifier] = c.id;
        }
        return prev;
    }, {});
    return function (p, item) {
        var length = (0, text_1.calculateStringLength)((item.type === 'FOLDER' ? item.path : item.name) || item.name);
        var prevValue = p['__name'];
        if (prevValue && prevValue.length < length) {
            prevValue.text = item.name;
            prevValue.length = length;
        }
        else if (!prevValue) {
            p['__name'] = {
                text: item.name,
                length: length
            };
        }
        var description = item.customMeta[metaIdLookup['description-meta']];
        var author = item.customMeta[metaIdLookup['added-by-meta']];
        var added = item.customMeta[metaIdLookup['added-meta']];
        if (description) {
            var text = description;
            var length_1 = (0, text_1.calculateStringLength)(text);
            var prevValue_1 = p['__description'];
            if (prevValue_1 && prevValue_1.length < length_1) {
                prevValue_1.text = text;
                prevValue_1.length = length_1;
            }
            else if (!prevValue_1) {
                p['__description'] = {
                    text: text,
                    length: length_1
                };
            }
        }
        if (author) {
            var text = author;
            var length_2 = (0, text_1.calculateStringLength)(text);
            var prevValue_2 = p['__author'];
            if (prevValue_2 && prevValue_2.length < length_2) {
                prevValue_2.text = text;
                prevValue_2.length = length_2;
            }
            else if (!prevValue_2) {
                p['__author'] = {
                    text: text,
                    length: length_2
                };
            }
        }
        if (added) {
            var text = moment(added)
                .format('L')
                .toString();
            var length_3 = (0, text_1.calculateStringLength)(text);
            var prevValue_3 = p['__added'];
            if (prevValue_3 && prevValue_3.length < length_3) {
                prevValue_3.text = text;
                prevValue_3.length = length_3;
            }
            else if (!prevValue_3) {
                p['__added'] = {
                    text: text,
                    length: length_3
                };
            }
        }
        return p;
    };
};
var compareOpts = {
    numeric: true,
    sensitivity: 'base'
};
function comparePaths(a, b) {
    var ap = (a.path || a.name).replace(/(^\/)|(\/$)/g, '').split('/');
    var bp = (b.path || b.name).replace(/(^\/)|(\/$)/g, '').split('/');
    var min = Math.min(ap.length, bp.length);
    for (var i = 0; i < min; i++) {
        if (i === min - 1 && ap.length === bp.length) {
            if (a.type === 'FOLDER' && b.type !== 'FOLDER') {
                return 1;
            }
            if (a.type !== 'FOLDER' && b.type === 'FOLDER') {
                return -1;
            }
        }
        var at = ap[i];
        var bt = bp[i];
        var res = at.localeCompare(bt, undefined, compareOpts);
        if (b.type !== 'FOLDER' && bp.length < ap.length) {
            if (bt === b.name) {
                return 1;
            }
        }
        if (a.type !== 'FOLDER' && ap.length < bp.length) {
            if (at === a.name) {
                return -1;
            }
        }
        if (res === 0) {
            continue;
        }
        return res;
    }
    return 0;
}
var sort = function (files, currentFrame) {
    var parents = files.reduce(function (prev, next) {
        prev[next.id] =
            !currentFrame.deleted[next.id] || !currentFrame.hardDeleted[next.id];
        return prev;
    }, {});
    var sortedFiles = __spreadArray([], files, true).sort(function (a, b) {
        if (!parents[a.parent] && !!parents[b.parent] && a.type !== 'FOLDER')
            return -1;
        if (!!parents[a.parent] && !parents[b.parent] && b.type !== 'FOLDER')
            return 1;
        if (!parents[a.parent] && !parents[b.parent]) {
            if (b.type === 'FOLDER' && a.type !== 'FOLDER')
                return -1;
            if (a.type === 'FOLDER' && b.type !== 'FOLDER')
                return 1;
        }
        return comparePaths(a, b);
    });
    if (sortedFiles.length === 0) {
        return sortedFiles;
    }
    var withoutParent = [];
    var ordered = [];
    for (var i = 0; i < sortedFiles.length; i++) {
        currentFrame.deleted[sortedFiles[i].parentUuid] &&
            sortedFiles[i].type !== 'FOLDER'
            ? withoutParent.push(sortedFiles[i])
            : ordered.push(sortedFiles[i]);
    }
    return withoutParent.concat(ordered);
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('_files', '_setFiles', []), (0, recompose_1.withState)('uuid', 'setUuid', ''), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _this = this;
        var files = this.props.files.filter(function (f) { return !_this.props.currentFrame.hardDeleted[f.uuid]; });
        var sortedFiles = sort(files, this.props.currentFrame);
        this.props._setFiles(sortedFiles);
        this.props.setUuid((0, uuid_1.v4)());
        var columns = files.reduce(calculateColumns(this.props.metadata.list), {});
        headers.forEach(function (x) {
            var dataKey = '__' + x.replace(/-/g, '');
            var text = (0, translation_1.getLocalization)("userfront/orderwizard/filelist/header/".concat(x)).toString();
            var length = (0, text_1.calculateStringLength)(text) + 22;
            var prevValue = columns[dataKey];
            if (prevValue && prevValue.length < length) {
                prevValue.text = text;
                prevValue.length = length;
            }
            else if (!prevValue) {
                columns[dataKey] = {
                    text: text,
                    length: length
                };
            }
        });
        var lengths = Object.keys(columns).reduce(function (prev, x) {
            prev[x] = columns[x].length;
            return prev;
        }, {});
        // Override styles for dynamic classes
        var style = document.getElementById('OrderFileListCSS');
        if (style && style.parentNode) {
            style.parentNode.removeChild(style);
        }
        style = document.createElement('style');
        style.id = 'OrderFileListCSS';
        document.head && document.head.appendChild(style);
        var sheet = style.sheet;
        var contentWidth = 2 * 42;
        Object.keys(lengths).forEach(function (className, i) {
            var colwidth = Math.max(8, 4 + lengths[className] + 26 * 0.6); // convert to rem
            contentWidth += colwidth;
            sheet.insertRule(".order-wizard-files-list-container .".concat(className) +
                ' {max-width: ' +
                colwidth +
                'px;\n min-width: ' +
                colwidth +
                'px;}', i);
        });
        contentWidth += 100;
        this.props.setContentWidth(contentWidth);
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        var files = this.props.files;
        if (prevProps.currentFrame.hardDeleted !==
            this.props.currentFrame.hardDeleted ||
            prevProps.files.length !== files.length ||
            prevProps.historyBrowsed !== this.props.historyBrowsed ||
            prevProps.selectedFiles !== this.props.selectedFiles) {
            var sortedFiles = sort(this.props.files.filter(function (f) { return !_this.props.currentFrame.hardDeleted[f.uuid]; }), this.props.currentFrame);
            this.props._setFiles(sortedFiles);
            var columns_1 = files.reduce(calculateColumns(this.props.metadata.list), {});
            headers.forEach(function (x) {
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("userfront/orderwizard/filelist/header/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 22;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue.length < length) {
                    prevValue.text = text;
                    prevValue.length = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = {
                        text: text,
                        length: length
                    };
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('OrderFileListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'OrderFileListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            var contentWidth_1 = 2 * 42;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26 * 0.6); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".order-wizard-files-list-container .".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
}), recompose_1.pure);
function getHeaderColumn(name, identifier) {
    var dataKey = "__".concat(String(identifier));
    return (React.createElement("div", { key: String(identifier), "data-key": dataKey, "data-length": name.length, className: classNames('column dynamic order-wizard-list-row-column extends', dataKey) },
        React.createElement("div", null, (0, translation_1.getLocalization)("userfront/orderwizard/filelist/header/".concat(name)))));
}
function getColumn(column, value, title, excluded) {
    if (excluded === void 0) { excluded = false; }
    if (excluded) {
        return (React.createElement("del", { title: title, className: classNames("row__column dynamic __".concat(column), column === 'name' && 'expand'), "data-key": "__".concat(column) }, value));
    }
    return (React.createElement("div", { title: title, className: classNames("row__column dynamic __".concat(column), column === 'name' && 'expand', column === 'select' && 'narrow'), "data-key": "__".concat(column) }, value));
}
var Header = function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column narrow icon" }),
        React.createElement("div", { className: "row__column narrow icon" }),
        getHeaderColumn('color', 'color'),
        getHeaderColumn('name', 'name'),
        getHeaderColumn('description', 'description'),
        getHeaderColumn('author', 'author'),
        getHeaderColumn('added', 'added')));
};
var createRowData = memoize(function (metadata, items, disabled, colored, hardDeleted, selectedFiles, selectColor, unselectFile, selectFile, uuid, disableFields, disableColorChange) { return ({
    metadata: metadata,
    items: items,
    disabled: disabled,
    colored: colored,
    hardDeleted: hardDeleted,
    selectedFiles: selectedFiles,
    selectColor: selectColor,
    unselectFile: unselectFile,
    selectFile: selectFile,
    uuid: uuid,
    disableFields: disableFields,
    disableColorChange: disableColorChange
}); });
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var metadata = data.metadata, items = data.items, disabled = data.disabled, colored = data.colored, hardDeleted = data.hardDeleted, selectedFiles = data.selectedFiles, selectColor = data.selectColor, unselectFile = data.unselectFile, selectFile = data.selectFile, disableFields = data.disableFields, disableColorChange = data.disableColorChange;
    var row = items[index];
    var selected = selectedFiles.findIndex(function (x) { return x === row.uuid; }) !== -1;
    var color = colored[row.uuid];
    if (color === undefined) {
        color = row.color;
    }
    if (color === undefined && metadata['color-meta'] !== undefined) {
        color = row.customMeta[metadata['color-meta'].id];
    }
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow __file-icon" }, (0, FileIcon_1.typeToIconAndTextMap)(row.type).icon),
        getColumn('select', React.createElement(components_1.TableRowIcon, { icon: 'fa-check', circle: true, onClick: function () { return (selected ? unselectFile([row]) : selectFile([row])); }, className: selected ? 'selected' : null, disabled: disableFields })),
        getColumn('color', React.createElement(sok_ui_1.Input, { type: "checkbox", value: color, onClick: function () { return selectColor(row, !color); }, disabled: disableColorChange ||
                disableFields ||
                !!disabled[row.uuid] ||
                row.type === 'FOLDER' })),
        getColumn('name', row.type === 'FOLDER' && row.path
            ? row.path.replace(/^Root\//, '')
            : row.name, row.path, !!disabled[row.uuid]),
        getColumn('description', row.customMeta[metadata['description-meta'].id]
            ? row.customMeta[metadata['description-meta'].id]
            : ''),
        getColumn('author', row.customMeta[metadata['added-by-meta'].id]
            ? row.customMeta[metadata['added-by-meta'].id]
            : '-'),
        getColumn('added', moment(row.customMeta[metadata['added-meta'].id]).format('L')),
        React.createElement("div", { className: "row__column narrow" })));
});
exports.FileList = enhance(function (props) {
    // memoize item props into props.data object
    var itemData = createRowData(props.metadata.list.reduce(function (p, c) {
        p[c.identifier] = c;
        return p;
    }, {}), props._files, props.currentFrame.deleted, props.currentFrame.colored, props.currentFrame.hardDeleted, props.selectedFiles, props.changeColor, function (files) {
        props.unselectFile(files.map(function (x) { return x.uuid; }));
    }, function (files) {
        props.selectFile(files.map(function (x) { return x.uuid; }));
    }, props.uuid, props.disableFields, props.disableColorChange);
    return (React.createElement("div", { className: 'order-wizard-files-list-container' },
        props.metadata.status === 'FAILURE' && (React.createElement("div", null,
            React.createElement(GenericErrorMessage_1.default, null))),
        props.metadata.status === 'FETCHING' && (React.createElement("div", { className: 'center-content' },
            React.createElement(sok_ui_1.LoadingSpinner, null))),
        props.metadata.status === 'FETCHED' && (React.createElement("div", { className: 'sok-list-content order-files-view-list' },
            React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { itemCount: props._files.length, itemData: itemData, overscanCount: 8, width: width, height: Math.min((props._files.length + 1) * 50, height), itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)) }, ListRow));
            })))));
});
exports.default = exports.FileList;
